import authService from "../../../../../../components/api-authorization/AuthorizeService";
import React, { useState, useEffect, useCallback } from "react";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useSelector, useDispatch, useStore } from "react-redux";
import "../../../../../../assets/css/test.css";
import {
  container,
  title,
  main,
  mainRaised,
  mrAuto,
  blackColor,
  infoColor,
  mlAuto,
  hexToRgb,
} from "../../../../../../assets/jss/material-kit-pro-react.js";
import { isEmpty } from "lodash";
import Simplert from "react-simplert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatCurrency } from "../../../../../utils/formatNumber";
import Lottie from "react-lottie";
import animationData from "../../../../../../assets/lotties/loadLottie.json";
import { updateForceUserBack, InsertOrder } from "../../../../../store/actions";
import { useHistory } from "react-router-dom";
import {
  ExpressCheckoutElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import LoadingModal from "../../../../../../components/LoadingModal";
import StripeSVG from "../../../../../../assets/img/stripe.svg";

const useStyles = makeStyles((theme) => ({
  main,
  mainRaised,
  mrAuto,
  mlAuto,
  container: {
    ...container,
    zIndex: 2,
  },
  title: {
    ...title,
    "&, & + h4": {
      /*            color: whiteColor,*/
    },
  },
  textCenter: {
    textAlign: "center",
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },
  left: {
    float: "left!important",
    display: "block",
  },
  right: {
    margin: "0",
    float: "right!important",
    display: "block",
  },
  icon: {
    width: "18px",
    height: "18px",
    top: "3px",
    position: "relative",
  },
  subHeader: {
    ...title,
    "&, & + h2": {},
    padding: "20px 0 10px 0",
    textAlign: "justify",
  },
  content: {
    paddingBottom: "55px",
    paddingTop: "2px",
  },
  checked: {
    color: infoColor[0] + "!important",
  },
  checkedIcon: {
    width: "25px",
    height: "25px",
    border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
    borderRadius: "3px",
  },
  uncheckedIcon: {
    width: "25px",
    height: "25px",
    padding: "9px",
    border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
    borderRadius: "3px",
  },
  closebuttonPopUp: {
    backgroundColor: "#006666",
    border: "none",
    color: "white",
    padding: "15px 28px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    margin: "13px 2px",
    cursor: "pointer",
  },
  confirmbuttonPopUp: {
    backgroundColor: "#00b300",
    border: "none",
    color: "white",
    padding: "15px 28px",
    textAlign: "center",
    textDecoration: "none",
    display: "inline-block",
    margin: "13px 2px",
    cursor: "pointer",
  },
  checkRoot: {
    padding: "14px",
    "&:hover": {
      backgroundColor: "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
    },
  },
  stripeElement: {
    padding: "16.5px 14px",
    border: "1px solid #c4c4c4",
    borderRadius: "4px",
    backgroundColor: "white",
    "&:focus": {
      borderColor: "#1976d2",
      outline: "none",
    },
  },
  summarySection: {
    width: "80%",
    maxWidth: "100vw",
  },
  summaryTitle: {
    marginLeft: "10px",
    fontWeight: "500",
  },
  summaryTitleContainer: {
    borderBottom: "1px dashed grey",
  },
  divider: {
    paddingBottom: "16px",
    paddingTop: "16px",
    marginBottom: "8px",
    marginTop: "8px",
    alignItems: "center",
    display: "flex",
    "& hr": {
      width: "100%",
      color: "#1a1a1a1a",
      height: "1px",
      border: "none",
    },
  },
}));

const notifyErrorMessage = () =>
  toast.error("Please fill in the required fields before proceeding!", {
    position: "bottom-right",
    autoClose: 4500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });

// Main component function
function InputPaymentDetails({ clientSecret }) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useStore();

  // Redux state
  const {
    nmbsReference,
    user,
    selectedDeliverySiteId,
    reqDelDate,
    totalWeight,
    branchId,
    orderSummaryResult,
    specialInstructions,
    cusOrderNumber,
    returnPalllets,
    tileInterest,
    quoteId,
  } = useSelector((state) => ({
    nmbsReference: state.orderReducer.nmbsReference,
    user: state.userReducer.user,
    selectedDeliverySiteId: state.orderReducer.selectedDeliverySiteId,
    reqDelDate: state.orderReducer.reqDelDate,
    totalWeight: state.orderReducer.totalWeight,
    branchId: state.orderReducer.selectedBranchId,
    orderSummaryResult: state.orderReducer.orderSummaryResult,
    specialInstructions: state.orderReducer.specialInstructions,
    cusOrderNumber: state.orderReducer.cusOrderNumber,
    returnPalllets: state.orderReducer.palletsRequired,
    tileInterest: state.orderReducer.tileInterest,
    quoteId: state.orderReducer.selectedQuoteId,
  }));

  // Stripe hooks
  const stripe = useStripe();
  const elements = useElements();

  // State
  const [state, setState] = useState({
    defaultAddress: [],
    disable: false,
    showAlert: false,
    typeAlert: "",
    titleAlert: "",
    messageAlert: "",
    useConfirmBtn: false,
    processingPayment: false,
  });
  const handlePaymentSuccess = (paymentMethodId) => {
    console.log("Payment method ID:", paymentMethodId);
  };
  const handlePaymentError = (errorMessage) => {
    console.error("Payment error:", errorMessage);
  };

  // Stripe field errors and processing state for inline payment form
  const [processing, setProcessing] = useState(false);
  const [cardNumberError, setCardNumberError] = useState("");
  const [cardExpiryError, setCardExpiryError] = useState("");
  const [cardCvcError, setCardCvcError] = useState("");
  const [showExpressLoading, setShowExpressLoading] = useState(true);

  // Helper functions
  const updateState = useCallback((updates, callback) => {
    setState((prevState) => {
      const newState = { ...prevState, ...updates };
      if (callback) callback();
      return newState;
    });
  }, []);

  const displayMessage = useCallback(
    (type, title, message) => {
      updateState(
        {
          showAlert: true,
          typeAlert: type,
          titleAlert: title,
          messageAlert: message,
          disable: false,
        },
        () => {
          window.scrollTo(0, 0);
        }
      );
    },
    [updateState]
  );

  const handlePopUpMessage = useCallback(() => {
    updateState({ showAlert: false });
  }, [updateState]);

  const ConfirmCardPayment = useCallback(async () => {
    try {
      const cardElement = elements.getElement(CardNumberElement);
      const { error, paymentIntent } = await stripe.confirmCardPayment(
        clientSecret,
        {
          payment_method: { card: cardElement },
        }
      );

      if (error) {
        displayMessage(
          "error",
          "Payment Error",
          error.message ||
            "There has been an error with the payment transaction. Please try again or contact our sales team if the problem persists."
        );
      } else if (paymentIntent.status === "succeeded") {
        await insertOrder(paymentIntent.id);
      }
    } catch (e) {
      displayMessage(
        "error",
        "Order Declined",
        "There has been an error during the payment process. Please try again or contact our sales team if the problem persists."
      );
    }
  }, [stripe, elements, clientSecret, displayMessage]);

  const ConfirmWalletPayment = useCallback(
    async (event) => {
      try {
        event.preventDefault(); // Prevent Stripe’s internal auto-confirm if needed
        if (!stripe || !elements || !clientSecret) return;
        const { error, paymentIntent } = await stripe.confirmPayment({
          elements,
          clientSecret,
          confirmParams: {
            return_url: window.location.href,
          },
          redirect: "if_required",
        });

        if (error) {
          displayMessage(
            "error",
            "Payment Error",
            error.message ||
              "There has been an error with the payment transaction. Please try again or contact our sales team if the problem persists."
          );
        } else if (paymentIntent.status === "succeeded") {
          await insertOrder(paymentIntent.id);
        }
      } catch (e) {
        displayMessage(
          "error",
          "Order Declined",
          "There has been an error during the payment process. Please try again or contact our sales team if the problem persists."
        );
      }
    },
    [stripe, elements, clientSecret, displayMessage]
  );

  const insertOrder = useCallback(
    async (paymentIntentId) => {
      try {
        await dispatch(
          InsertOrder(
            orderSummaryResult,
            specialInstructions,
            reqDelDate,
            cusOrderNumber,
            branchId,
            selectedDeliverySiteId,
            totalWeight,
            nmbsReference,
            true,
            returnPalllets,
            tileInterest,
            quoteId,
            paymentIntentId
          )
        );

        const fpmccann_OrderNumber =
          store.getState().orderReducer.fpmccann_OrderNumber;

        if (!isEmpty(fpmccann_OrderNumber)) {
          history.push("/OrderConfirmation");
        } else {
          history.push("/error-page");
        }
      } catch (e) {
        history.push("/error-page");
      }
    },
    [
      dispatch,
      orderSummaryResult,
      specialInstructions,
      reqDelDate,
      cusOrderNumber,
      branchId,
      selectedDeliverySiteId,
      totalWeight,
      nmbsReference,
      returnPalllets,
      tileInterest,
      quoteId,
      history,
      updateState,
    ]
  );

  const ValidateCard = useCallback(async () => {
    // Validate card, cvc, and expiry before proceeding
    if (!elements) {
      console.log("Elements is validatecard:", elements);
      return true; // or handle error as needed
    }
    const cardNumberElement = elements.getElement(CardNumberElement);
    const cardExpiryElement = elements.getElement(CardExpiryElement);
    const cardCvcElement = elements.getElement(CardCvcElement);

    if (!cardNumberElement || !cardExpiryElement || !cardCvcElement) {
      setCardNumberError("Card information fields are not available.");
      setCardExpiryError("Card information fields are not available.");
      setCardCvcError("Card information fields are not available.");
      return true;
    }

    let hasError = false;

    // Validate Card Number
    if (cardNumberElement) {
      const cardNumberResult = (await cardNumberElement._completePromise)
        ? await cardNumberElement._completePromise
        : { complete: cardNumberElement._complete || false };

      if (!cardNumberResult.complete) {
        setCardNumberError("Please enter a valid card number.");
        hasError = true;
      } else {
        setCardNumberError("");
      }
    }

    // Validate Card Expiry
    if (cardExpiryElement) {
      const cardExpiryResult = (await cardExpiryElement._completePromise)
        ? await cardExpiryElement._completePromise
        : { complete: cardExpiryElement._complete || false };

      if (!cardExpiryResult.complete) {
        setCardExpiryError("Please enter a valid expiration date.");
        hasError = true;
      } else {
        setCardExpiryError("");
      }
    }

    // Validate Card CVC
    if (cardCvcElement) {
      const cardCvcResult = (await cardCvcElement._completePromise)
        ? await cardCvcElement._completePromise
        : { complete: cardCvcElement._complete || false };

      if (!cardCvcResult.complete) {
        setCardCvcError("Please enter a valid CVC.");
        hasError = true;
      } else {
        setCardCvcError("");
      }
    }

    return hasError;
  }, [elements]);

  const payWithWallet = useCallback(
    async (event) => {
      if (!elements || !stripe) {
        return;
      }

      updateState({ processingPayment: true });
      try {
        await ConfirmWalletPayment(event);
      } catch (e) {
        history.push("/error-page");
      } finally {
        updateState({ processingPayment: false });
      }
    },
    [orderSummaryResult, ConfirmWalletPayment]
  );

  const PayWithCard = useCallback(async () => {
    if (!elements || !stripe) {
      return;
    }
    // Validate card, cvc, and expiry before proceeding
    // Assumes setCardNumberError, setCardExpiryError, setCardCvcError and elements are in scope
    let hasError = false;
    hasError = await ValidateCard();

    if (hasError) {
      return;
    }

    updateState({ processingPayment: true });

    try {
      await ConfirmCardPayment();
    } catch (e) {
      history.push("/error-page");
    } finally {
      updateState({ processingPayment: false });
    }
  }, [orderSummaryResult, ConfirmCardPayment]);

  // Effects
  useEffect(() => {
    const initializeComponent = async () => {
      if (isEmpty(user) && isEmpty(orderSummaryResult)) {
        await dispatch(updateForceUserBack(true));
      } else {
        updateState({ emailAddress: user.email, userSavedInStore: true });
      }
    };

    initializeComponent();
  }, [user, orderSummaryResult, dispatch, updateState]);

  // Render
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const { showAlert, typeAlert, titleAlert, messageAlert } = state;

  let summaryModal = (
    <div className={classes.summarySection}>
      <div>
        <div>
          <div className={classes.summaryTitleContainer}>
            <p className={classes.summaryTitle}>Order Summary</p>
          </div>
          <div
            className="order-summary-body-container"
            style={{ width: "100%" }}
          >
            <div
              className="order-summary-body-container"
              style={{ width: "100%" }}
            >
              <div className="price-item-container subtotal">
                <p className="price-item-label">Price (Ex VAT)</p>
                <p className="price">
                  {" "}
                  {formatCurrency(orderSummaryResult.original_Total_price)}
                </p>
              </div>

              <div
                className="order-summary-body-container"
                style={{ width: "100%", borderBottom: "1px dashed grey" }}
              >
                <div className="price-item-container subtotal">
                  <p className="price-item-label">VAT Amount</p>
                  <p className="price">
                    {formatCurrency(orderSummaryResult.vaT_Amount)}
                  </p>
                </div>

                <div className="price-item-container subtotal">
                  <p className="price-item-label">VAT (%)</p>
                  <p className="price">{orderSummaryResult.vat}%</p>
                </div>
              </div>

              <div className="price-item-container order-total">
                <p className="price-item-label">Order Total</p>
                <p className="price">
                  {" "}
                  {formatCurrency(orderSummaryResult.total_Price_Inc_VAT)}{" "}
                </p>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <LoadingModal
        active={state.processingPayment}
        text="Processing your payment, please do not refresh or exit the page..."
      />
      <div className={classes.content}>
        <div style={{ width: "100%" }}>
          <div style={{ padding: "10x" }}>
            <h2
              className={classes.title}
              style={{ borderBottom: "2px dashed grey", padding: "5px" }}
            >
              <i className="far fa-credit-card"></i> Confirm Payment
            </h2>

            <Simplert
              style={{
                width: "250px;",
                overflow: "auto",
                fontWeight: "600px",
              }}
              showSimplert={showAlert}
              type={typeAlert}
              title={titleAlert}
              message={messageAlert}
              onClose={handlePopUpMessage}
              disableOverlayClick={true}
              customCloseBtnClass={classes.closebuttonPopUp}
            />

            <div>
              <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
              />
            </div>

            <Grid container spacing={0}>
              <Grid
                item
                container
                direction="column"
                xs={12}
                sm={4}
                style={{ justifyContent: "space-between" }}
              >
                <Grid container spacing={2}>
                  {summaryModal}
                </Grid>
                <Grid container spacing={2} style={{ margin: "0 0 15px 10px" }}>
                  <div>
                    <Button
                      style={{
                        borderRadius: 2,
                        padding: "16px 20px",
                        fontSize: "15px",
                      }}
                      color="danger"
                      size="lg"
                      target="_blank"
                      onClick={() => history.goBack()}
                    >
                      <i className="far fa-window-close"></i>
                      &nbsp; Back
                    </Button>
                  </div>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                style={{
                  padding: "32px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    {/* Wallets (Google Pay / Apple Pay / Link) */}
                    {showExpressLoading && (
                      <div>
                        <Lottie
                          options={defaultOptions}
                          height={60}
                          width={60}
                        />
                      </div>
                    )}
                    <ExpressCheckoutElement
                      onReady={() => setShowExpressLoading(false)}
                      onConfirm={payWithWallet}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div
                      style={{
                        position: "relative",
                        textAlign: "center",
                        width: "100%",
                        margin: "24px 0",
                      }}
                    >
                      <hr
                        style={{
                          border: "none",
                          borderTop: "1px solid #e0e0e0",
                          margin: 0,
                        }}
                      />
                      <span
                        style={{
                          backgroundColor: "#fff",
                          position: "absolute",
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          padding: "0 16px",
                          color: "#888",
                          fontWeight: 500,
                          fontSize: "15px",
                          letterSpacing: "1px",
                        }}
                      >
                        Or pay with card
                      </span>
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <h
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#1a1a1ab3",
                      }}
                    >
                      Card Number
                    </h>
                    <div className={classes.stripeElement}>
                      <CardNumberElement
                        options={{
                          style: {
                            base: {
                              fontSize: "16px",
                              color: "#424770",
                              "::placeholder": { color: "#aab7c4" },
                            },
                          },
                          showIcon: true,
                        }}
                        onChange={(event) =>
                          setCardNumberError(
                            event.error ? event.error.message : ""
                          )
                        }
                      />
                    </div>
                    {cardNumberError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.9em",
                          marginTop: 4,
                        }}
                      >
                        {cardNumberError}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <h
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#1a1a1ab3",
                      }}
                    >
                      Expiry Date
                    </h>
                    <div className={classes.stripeElement}>
                      <CardExpiryElement
                        options={{
                          style: {
                            base: {
                              fontSize: "16px",
                              color: "#424770",
                              "::placeholder": { color: "#aab7c4" },
                            },
                          },
                        }}
                        onChange={(event) =>
                          setCardExpiryError(
                            event.error ? event.error.message : ""
                          )
                        }
                      />
                    </div>
                    {cardExpiryError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.9em",
                          marginTop: 4,
                        }}
                      >
                        {cardExpiryError}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <h
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#1a1a1ab3",
                      }}
                    >
                      CVC
                    </h>
                    <div className={classes.stripeElement}>
                      <CardCvcElement
                        options={{
                          style: {
                            base: {
                              fontSize: "14px",
                              color: "#424770",
                              "::placeholder": { color: "#aab7c4" },
                            },
                          },
                        }}
                        onChange={(event) =>
                          setCardCvcError(
                            event.error ? event.error.message : ""
                          )
                        }
                      />
                    </div>
                    {cardCvcError && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.9em",
                          marginTop: 4,
                        }}
                      >
                        {cardCvcError}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <div className="secure-checkout-button">
                      <Button
                        color="behance"
                        style={{
                          width: "100%",
                          padding: "12x 0px",
                          fontSize: "15px",
                        }}
                        disabled={
                          state.disable || processing || !stripe || !elements
                        }
                        onClick={PayWithCard}
                      >
                        <span style={{ textTransform: "capitalize" }}>
                          {processing
                            ? "Processing..."
                            : `Pay ${formatCurrency(
                                orderSummaryResult.total_Price_Inc_VAT
                              )}`}
                        </span>
                      </Button>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "18px",
                        fontSize: "14px",
                        color: "#999",
                      }}
                    >
                      <a
                        href="https://stripe.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          cursor: "pointer",
                          color: "inherit",
                          border: "none",
                          background: "none",
                          outline: "none",
                          marginRight: 14,
                        }}
                      >
                        <span style={{ marginRight: 6 }}>Powered by</span>
                        <img
                          src={StripeSVG}
                          alt="Stripe"
                          style={{
                            height: 38,
                            verticalAlign: "middle",
                            marginTop: "-2px",
                          }}
                        />
                      </a>
                      <span
                        style={{
                          borderLeft: "1px solid #ddd",
                          height: 20,
                          margin: "-2px 14px 0 0",
                        }}
                      ></span>
                      <a
                        href="https://stripe.com/legal/payment-terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "inherit",
                          border: "none",
                          background: "none",
                          outline: "none",
                          textDecoration: "none",
                          marginRight: 14,
                          marginTop: "-2px",
                        }}
                      >
                        Terms
                      </a>
                      <a
                        href="https://stripe.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "inherit",
                          border: "none",
                          background: "none",
                          outline: "none",
                          textDecoration: "none",
                          marginTop: "-2px",
                        }}
                      >
                        Privacy
                      </a>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
}
export default InputPaymentDetails;
